export default "__VITE_ASSET__BaacXeZI__"